import { RefObject } from "react";

import { IComponent, ILink } from "@multiweb/picasso";
import { IActivity, IParticipant, ISet, ITransition } from "./types";
import { UiModelCreator } from "./UiModelCreator";
import { UiSet } from "./UiSet";
import { Workflow } from "./workflowModel";

export class UiWorkflow {
    private _editorElementRef: RefObject<HTMLDivElement>;

    public workflow: Workflow;
    public picassoModel: { components: IComponent[]; links: ILink[] };
    public setIsWfEdited: (isEdited: boolean) => Promise<void>;

    constructor(workflow: Workflow, selectedSetId: string | undefined, editorElementRef: RefObject<HTMLDivElement>, setIsWfEdited: (isEdited: boolean) => Promise<void>) {
        this.workflow = workflow;
        this.picassoModel = UiModelCreator.getUiModel(this.workflow, selectedSetId);
        this._editorElementRef = editorElementRef;
        this.setIsWfEdited = setIsWfEdited;
    }

    public get uiSet(): UiSet {
        return this.picassoModel.components[0] as UiSet;
    }

    public get workflowModel(): { sets: ISet[]; activities: IActivity[]; transitions: ITransition[]; definitionParticipants: IParticipant[] } {
        return UiModelCreator.getWorkflowEntities(this);
    }

    public get editorElement(): HTMLDivElement {
        if (this._editorElementRef.current) {
            return this._editorElementRef.current;
        }
        throw new Error("Reference to workflow editor element not found!");
    }

    public updatePicassoModel(activeSetId: string): void {
        this.picassoModel = UiModelCreator.getUiModel(this.workflow, activeSetId);
    }
}
